import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from '@mui/material';

interface BulkPriceUpdateDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  priceUpdateType: 'percentage' | 'fixed';
  priceUpdateValue: number;
  priceUpdateTarget: 'sale' | 'purchase';
  currencySymbol: string;
  onPriceTypeChange: (type: 'percentage' | 'fixed') => void;
  onPriceValueChange: (value: number) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkPriceUpdateDialog: React.FC<BulkPriceUpdateDialogProps> = ({
  open,
  loading,
  selectedCount,
  priceUpdateType,
  priceUpdateValue,
  priceUpdateTarget,
  currencySymbol,
  onPriceTypeChange,
  onPriceValueChange,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onCancel : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {priceUpdateTarget === 'sale' ? 'Toplu Satış Fiyatı Güncelleme' : 'Toplu Alım Fiyatı Güncelleme'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seçili {selectedCount} adet stok ürününün {priceUpdateTarget === 'sale' ? 'satış' : 'alım'} fiyatı güncellenecektir.
        </DialogContentText>
        <FormControl component="fieldset" sx={{ mt: 2, mb: 2 }}>
          <FormLabel component="legend">Güncelleme Türü</FormLabel>
          <RadioGroup
            row
            value={priceUpdateType}
            onChange={(e) => onPriceTypeChange(e.target.value as 'percentage' | 'fixed')}
          >
            <FormControlLabel value="percentage" control={<Radio />} label="Yüzde" />
            <FormControlLabel value="fixed" control={<Radio />} label="Sabit Değer" />
          </RadioGroup>
        </FormControl>
        <TextField
          fullWidth
          type="number"
          label={priceUpdateType === 'percentage' ? 'Yüzde Değeri' : 'Sabit Değer'}
          variant="outlined"
          value={priceUpdateValue}
          onChange={(e) => onPriceValueChange(Number(e.target.value))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {priceUpdateType === 'percentage' ? '%' : currencySymbol}
              </InputAdornment>
            ),
          }}
          helperText={priceUpdateType === 'percentage' 
            ? "Örnek: 10 için fiyatlar %10 artacak, -10 için %10 azalacak" 
            : "Örnek: 10 için fiyatlara 10TL eklenecek, -10 için 10TL düşecek"}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onCancel} 
          color="primary"
          disabled={loading}
        >
          İptal
        </Button>
        <Button 
          onClick={onConfirm} 
          color="primary" 
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
        >
          {loading ? 'Güncelleniyor...' : 'Güncelle'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

